import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import { useNavigate, useParams } from "react-router-dom";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useEffect, useState } from "react";
import CommonForm from "../../../components/form/form";
import {
  deleteUser,
  exportUser,
  getUserList,
  updateUser,
} from "../../../../services/workspace/user.service";
import { getDepartmentList } from "../../../../services/workspace/department.service";
import { convertToLabelValue } from "../../../../utils/common";
import toast from "react-hot-toast";
import { getDesignationList } from "../../../../services/workspace/designation.service";
import {
  commonConditions,
  createActionButtons,
} from "../../../../utils/actionButtonHelpers";

// Import export system
import { useDispatch } from "react-redux";
import { useExport } from "../../../../hooks";

const actions_type = {
  VIEW: "VIEW",
  ACTIVE: "ACTIVE",
  ADD_EDIT: "ADD_EDIT",
};

const items = [{ label: "Staff Directory", path: "" }];

const ManageStaffDirectory = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { exportToExcel } = useExport();
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedDesignationId, setSelectedDesignationId] = useState("");
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);

  const customCase = {
    1: {
      label: "Active",
      color: "text-green-600 text-sm",
      bg: "bg-green-600",
    },
    2: {
      label: "Inactive",
      color: "text-red-500 text-sm",
      bg: "bg-red-500",
    },
    3: {
      label: "Terminated",
      color: "text-red-500 text-sm",
      bg: "bg-red-500",
    },
    4: {
      label: "Inactive",
      color: "text-gray-500 text-sm",
      bg: "bg-gray-500",
    },
  };
  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    sortingUIProps,
    applyFilters,
    clearFilters,
  } = useCommonFetch(getUserList, {
    dataPath: "user.data",
    totalPath: "user.meta.total",
    errorMessage: "Failed to fetch user data!",
    debounceDelay: 500,
    customParams: {
      type: 2,
      with: "department,designation",
      user_status:"all"
    },
    sortingOptions: [
      {
        label: "Name",
        field: "name",
        buttonText: {
          ascending: "A-Z",
          descending: "Z-A",
        },
      },
      {
        label: "Staff ID",
        field: "code",
        buttonText: {
          ascending: "Asc",
          descending: "Dsc"
        }
      },
      {
        label: "Joining Date",
        field: "joining_at",
        buttonText: {
          ascending: "Oldest First",
          descending: "Newest First",
        },
      },
    ],
    filterModule: "staff",
    sortingModule: "staff",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    // Custom sorting button text - you can change these to any text you want
    sortingButtonText: {
      ascending: "A-Z",
      descending: "Z-A",
    },

    // Add data transformer function
    dataTransformer: (data) => {
      if (Array.isArray(data)) { 
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          uuid: {
            data: item?.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          id: {
            data: item?.code,
            className: "",
            sticky: false,
            variant: "text",
          },
          name: {
            data: {
              name: `${item?.name} ${item?.last_name ? item?.last_name : ""}`,
              email: item?.email,
              image: item?.image || "",
              link: `/hr/staff-directory/profile/${item?.uuid}`,
            },
            className: "",
            sticky: false,
            variant: "profile",
          },
          phone: {
            data: item?.phone,
            className: "",
            sticky: false,
            variant: "text",
          },
          username: {
            data: item?.username,
            className: "",
            sticky: false,
            variant: "text",
          },
          department: {
            data: item?.department?.name,
            className: "",
            sticky: false,
            variant: "text",
          },
          designation: {
            data: item?.designation?.name,
            className: "",
            sticky: false,
            variant: "text",
          },
          joining_at: {
            data: item?.joining_at,
            className: "",
            sticky: false,
            variant: "date",
          },
          created_at: {
            data: item?.created_at,
            className: "",
            sticky: false,
            variant: "date",
          },
          // Add any other transformations you need
          status: {
            data: item?.status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: customCase,
          },
          actions: {
            data: item?.id,
            className: "",
            sticky: false,
            variant: "text",
          },
        }));

        const actionButton = createActionButtons({
          active: {
            handler: (item) => {
              handleUpdate({ status: 1 }, item?.uuid?.data, updateUser, {
                successMessage: `User ${
                   "Activated"  
                } successfully!`,
                errorMessage: "Failed to update user status!",
              });
            },
            show: (item) => {
              // Check status from transformed field (status.data)
              // Since ...item is spread, original status might also be available
              const status = item.status?.data;
              // Debug: uncomment to see actual values
              // console.log('Active button - Full item:', item, 'Status data:', status);
              
              if (status === null || status === undefined) {
                // If no status in transformed data, check original (since ...item is spread)
                const originalStatus = item.status;
                if (originalStatus === null || originalStatus === undefined) return false;
                const statusNum = typeof originalStatus === 'string' ? parseInt(originalStatus, 10) : Number(originalStatus);
                return statusNum === 2 || statusNum === 0;
              }
              
              const statusNum = typeof status === 'string' ? parseInt(status, 10) : Number(status);
              // Show for inactive (2) or pending (0), but not for active (1)
              return (statusNum === 2 || statusNum === 0) && statusNum !== 1;
            },
          },
          inactive: {
            handler: (item) => {
              handleUpdate({ status: 2 }, item?.uuid?.data, updateUser, {
                successMessage: `User ${
                  "Inactivated"
                } successfully!`,
                errorMessage: "Failed to update user status!",
              });
            },
            show: commonConditions.activeOnly,
          },
          edit: {
            handler: (item) => {
              navigate(
                `/hr/staff-directory/edit/${
                  item?.uuid?.data ? `${item.uuid.data}` : ""
                }`
              );
            },
            show: commonConditions.activeOnly, // Show edit only for non-system generated items
          },
          assign: {
            handler: (item) => {
              navigate(
                `/hr/staff-directory/assign/${
                  item?.uuid?.data ? `${item.uuid.data}` : ""
                }`
              );
            },
            show: commonConditions.activeOnly,
          },
        });

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  const fetchDepartment = () => {
    getDepartmentList({})
      .then((response) => {
        setDepartmentList(
          convertToLabelValue(response.department.data || []) || []
        );
      })
      .catch((error) => {
        toast.error("Failed to fetch department data!");
      });
  };

  const fetchDesignation = (departmentId) => {
    if (!departmentId) {
      setDesignationList([]);
      return;
    }

    getDesignationList({ department_id: departmentId })
      .then((response) => {
        setDesignationList(
          convertToLabelValue(response.designation.data || []) || []
        );
      })
      .catch((error) => {
        toast.error("Failed to fetch designation data!");
        console.error(error);
      });
  };

  useEffect(() => {
    fetchDepartment();
  }, []);

  useEffect(() => {
    fetchDesignation(selectedDepartmentId);
  }, [selectedDepartmentId]);

  const TableHeaderData = [
    {
      label: "Staff ID",
      key: "id",
    },
    {
      label: "Username",
      key: "username",
    },
    {
      label: "Staff Name",
      key: "name",
    },
    {
      label: "Phone",
      key: "phone",
    },
    {
      label: "Department",
      key: "department",
    },
    {
      label: "Designation",
      key: "designation",
    },
    {
      label: "Joining Date",
      key: "joining_at",
    },
    {
      label: "Created At",
      key: "created_at",
    },
    {
      label: "Status",
      key: "status",
    },
  ];

  const handleImport = () => {
    
    navigate("/hr/staff-directory/import")
  };

  const handleExport = async () => {
    const exportPayload = {
      type: 2,
      reset: 0,
      department_id: selectedDepartmentId,
      designation_id: selectedDesignationId,
      status: selectedStatus,
    };
    try {
      await exportToExcel(exportUser, exportPayload, "Staff Directory Export");
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() =>
          navigate("/hr/staff-directory/add", actions_type.ADD_EDIT)
        }
        filter
        import_button
        export_button
        onClickImport={handleImport}
        onClickExport={handleExport}
        shorting
        breadcrumbs={items}
        sortingModule="staff"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        filterProps={{
          filterModule: "staff",
          onFilterChange: () =>
            applyFilters({
              department_id: selectedDepartmentId || undefined,
              designation_id: selectedDesignationId || undefined,
              status: selectedStatus || undefined,
            }),
          onClearFilters: () => {
            setSelectedDepartmentId("");
            setSelectedDesignationId("");
            setSelectedStatus("");
            clearFilters();
          },
          hasActiveFilters: !!selectedDepartmentId || !!selectedDesignationId,
        }}
      >
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Department
          </label>
          <select
            className="w-full border border-gray-300 rounded-md p-2 text-sm"
            value={selectedDepartmentId}
            onChange={(e) => setSelectedDepartmentId(e.target.value)}
          >
            <option value="">All</option>
            {Array.isArray(departmentList) &&
              departmentList.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
          </select>
        </div>
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Designation
          </label>
          <select
            className="w-full border border-gray-300 rounded-md p-2 text-sm"
            value={selectedDesignationId}
            onChange={(e) => setSelectedDesignationId(e.target.value)}
          >
            <option value="">All</option>
            {Array.isArray(designationList) &&
              designationList.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
          </select>
        </div>
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Status
          </label>
          <select
            className="w-full border border-gray-300 rounded-md p-2 text-sm"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="">All</option>
            <option value="1">Active</option>
            <option value="2">Inactive</option>
            <option value="3">Terminate</option>
          </select>
        </div>
      </PageTableHeader>

      <div className={"flex flex-col gap-2"}>
        <CommonTable
        search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
          actionTooltips={{ assign: "Salary Assign" }}
        />
      </div>
    </div>
  );
};
export default ManageStaffDirectory;
